/* istanbul ignore file */
import isFunction from 'lodash/isFunction';
export function resolveState(...args) {
    const stateOrFn = args[0];
    return (isFunction(stateOrFn) ?
        args.length === 1 ?
            stateOrFn()
            : stateOrFn(args[1])
        : stateOrFn);
}
//# sourceMappingURL=resolveState.js.map